export default {"src":"/_next/static/media/register-company.fd66c81b.svg","height":215,"width":286};